import { memo } from 'react';
import IncidentsHeaderNav from '../../components/HeadersNav/IncidentsHeaderNav';
import { Outlet } from 'react-router-dom';

const IncidentsPage = () => {
  return (
    <>
      <IncidentsHeaderNav />
      <Outlet />
    </>
  );
};

export default memo(IncidentsPage);
